import * as React from "react";
import {UseState}    from "@Common/react/use-state";
import {FontAwesomeIcon}        from "@fortawesome/react-fontawesome";
import {faChevronLeft, faChevronRight, faCircleInfo} from "@fortawesome/free-solid-svg-icons";

import "./bug-bounty-alert.scss";

import {cs} from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {SliderCheckbox} from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {Load2} from "@Common/react/load2";

export const BugBountyAlert = ({title, description, imageUrl, documentationLink, buttonType, buttonText, buttonChangeHandler, buttonLink, location="product_options", buildpath}) => cs(
    ["isExpanded", (_, next) => UseState({
        initValue: 1,
        next,
    })],
    ["isActive", (_, next) => UseState({
        initValue: 0,
        next,
    })],
    ["isExpandedChangeHandler", ({isExpanded}, next) => next(
        () => {
            const newVal = isExpanded.value == 0 ? 1 : 0;
            isExpanded.onChange(newVal)
        }
    )],
    ["isActiveChangeHandler", ({isActive}, next) => next(
        () => {
            const newVal = isActive.value == 0 ? 1 : 0;
            buttonChangeHandler(newVal);
            isActive.onChange(newVal)
        }
    )],

    ({isExpanded, isActive, isExpandedChangeHandler, isActiveChangeHandler}) => (
        <div className="bug-bounty-alert-b75">
            <div className={!!isExpanded.value ? "slideout-prompt" : "slideout-prompt slideout-prompt-toggle"}>
                <div className="expand-collapse-button" onClick={isExpandedChangeHandler}>
                    <FontAwesomeIcon icon={isExpanded.value ? faChevronRight : faChevronLeft} size="xl"/>
                </div>
                <div className="bug-bounty-main">
                    <div className="bug-bounty-image">
                        <img src={imageUrl} />
                    </div>
                    <div className="content">
                        <div className="title">{title}</div>
                        <div className="description">{description} <br/> <strong>Build Path:&nbsp;</strong> <i>{buildpath}</i></div>
                        {buttonType === "slider" ?
                            <div className="slider-button-cont">
                                <div className="slider-text">{buttonText}</div>
                                <SliderCheckbox
                                    value={!!isActive.value}
                                    onChange={isActiveChangeHandler}
                                    dark={true}
                                />
                            </div> :
                            <div className="bug-bounty-button-cont">
                                <div className="bug-bounty-button"
                                    onClick={() => window.open(buttonLink)}
                                >
                                    {buttonText}
                                </div>
                            </div>
                        }
                    </div>
                    {<div className="info-button-cont">{documentationLink && <FontAwesomeIcon icon={faCircleInfo} size="xl" onClick={() => window.open(documentationLink)}/>}</div>}
                </div>
            </div>
        </div>
    )
);